import React from 'react';
import { FiCheckCircle } from 'react-icons/fi';

/**
 * CheckCircleIcon
 * Ikona potvrdenia použitá na zvýraznenie úspešných akcií.
 */
const CheckCircleIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FiCheckCircle className={className} {...props} />
);

export default CheckCircleIcon;

